import { render, staticRenderFns } from "./index.vue?vue&type=template&id=365e7ebf&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=365e7ebf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e7ebf",
  null
  
)

export default component.exports